import React from "react";

// Container principal de la pagination
export const Pagination = ({ children }) => {
  return (
    <nav
      className="flex justify-center my-4"
      role="navigation"
      aria-label="pagination"
    >
      {children}
    </nav>
  );
};

// Conteneur pour les éléments de pagination
export const PaginationContent = ({ children }) => {
  return <ul className="inline-flex items-center space-x-1">{children}</ul>;
};

// Élément de pagination (li)
export const PaginationItem = ({ children }) => {
  return <li>{children}</li>;
};

// Lien (bouton) de pagination pour une page spécifique
export const PaginationLink = ({ page, isActive, onClick }) => {
  return (
    <button
      onClick={() => onClick(page)}
      className={`px-3 py-1.5 min-w-[36px] text-sm font-medium border rounded-full transition-colors duration-200
      ${isActive
    ? 'bg-black text-white border-black'
    : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-100 hover:text-black'}
`}

    >
      {page}
    </button>
  );
};

// Ellipsis pour indiquer une coupure dans la pagination
export const PaginationEllipsis = () => {
  return <span className="px-2 text-gray-400 select-none text-sm">…</span>;
};

// Bouton "Précédent"
export const PaginationPrevious = ({ disabled, onClick }) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className="px-3 py-1.5 text-sm font-medium border border-gray-300 rounded-full transition-colors duration-200 
        hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
    >
      Précédent
    </button>
  );
};

// Bouton "Suivant"
export const PaginationNext = ({ disabled, onClick }) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className="px-3 py-1.5 text-sm font-medium border border-gray-300 rounded-full transition-colors duration-200 
        hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
    >
      Suivant
    </button>
  );
};

// Exemple d'utilisation complet dans le même fichier
export const PaginationExample = ({ totalPages, currentPage, onPageChange }) => {
  const changePage = (page) => {
    if (page >= 1 && page <= totalPages) onPageChange(page);
  };

  // Gère l'affichage avec ellipsis
  const getDisplayedPages = () => {
    const pages = [];
    if (totalPages <= 7) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      pages.push(1);
      if (currentPage > 4) pages.push("ellipsis-start");
      const start = Math.max(2, currentPage - 1);
      const end = Math.min(totalPages - 1, currentPage + 1);
      for (let i = start; i <= end; i++) pages.push(i);
      if (currentPage < totalPages - 3) pages.push("ellipsis-end");
      pages.push(totalPages);
    }
    return pages;
  };

  return (
    <Pagination>
      <PaginationPrevious
        disabled={currentPage === 1}
        onClick={() => changePage(currentPage - 1)}
      />

      <PaginationContent>
        {getDisplayedPages().map((page, index) => (
          <PaginationItem key={index}>
            {page === "ellipsis-start" || page === "ellipsis-end" ? (
              <PaginationEllipsis />
            ) : (
              <PaginationLink
                page={page}
                isActive={currentPage === page}
                onClick={changePage}
              />
            )}
          </PaginationItem>
        ))}
      </PaginationContent>

      <PaginationNext
        disabled={currentPage === totalPages}
        onClick={() => changePage(currentPage + 1)}
      />
    </Pagination>
  );
};
